<!-- SuperAdmin Header Start-->
<div
	class="page-header"
	*ngIf="this.currentUser?.roles[0] === 'SuperAdmin' || this.currentUser?.roles[0] === 'Admin'"
	[class.close_icon]="navServices.collapseSidebar"
>
	<div class="header-wrapper row m-0">
		<div class="header-logo-wrapper col-auto p-0">
			<div class="logo-wrapper">
				<a routerLink="/">
					<img class="img-fluid for-light" src="assets/images/logo/logo.png" alt="" />
					<img class="img-fluid for-dark" src="assets/images/logo/logo_dark.png" alt="" />
				</a>
			</div>
			<div class="toggle-sidebar" (click)="sidebarToggle()">
				<app-feather-icons [icon]="'align-center'" class="status_toggle middle"></app-feather-icons>
			</div>
		</div>
		<div class="nav-right col-md-12 col-sm-12 pull-right right-header p-0 ms-auto">
			<ul class="nav-menus">
				<li class="profile-nav onhover-dropdown p-0" role="button">
					<app-project-selector></app-project-selector>
				</li>
				<li
					class="fullscreen-body d-flex gap-2 bg-white border border-gray-200 rounded-2 shadow-sm me-3 p-2 hover:shadow-md transition-all"
					*ngIf="
						['E-COMMERCE', 'COMMERCE', 'RESTAURANT', 'LIBRARY', 'SALON'].includes(
							this.selectedProject?.type
						) && hasAccessToPOS
					"
					role="button"
					(click)="this.router.navigate(['front/orders-management/' + selectedProject?._id + '/add'])"
				>
					<img src="assets/images/svg-icon/laptop.svg" style="width: 20px" />
					<span class="font-medium text-gray-800 me-2">{{ 'POS' | translate }}</span>
				</li>
				<li
					role="button"
					class="fullscreen-body d-flex gap-2 border border-gray-200 rounded-2 shadow-sm me-3 p-2 hover:shadow-md transition-all"
					style="background-color: #e04f16"
					(click)="openMathCalculator()"
				>
					<app-svg-icon [imageIcon]="'calculator-2'"></app-svg-icon>
				</li>
				<li class="fullscreen-body">
					<app-toggle-screen></app-toggle-screen>
				</li>
				<li class="onhover-dropdown">
					<app-notification></app-notification>
				</li>
				<li class="language-nav" (click)="languageToggle()">
					<app-languages></app-languages>
				</li>
				<li class="onhover-dropdown p-0">
					<app-header-settings></app-header-settings>
				</li>
				<li class="onhover-dropdown">
					<app-header-administration></app-header-administration>
				</li>
				<li class="profile-nav onhover-dropdown p-0" role="button">
					<app-my-account></app-my-account>
				</li>
			</ul>
		</div>
	</div>
</div>
<!-- SuperAdmin Header Ends -->

<!-- User Header Start-->
<div
	class="page-header"
	*ngIf="emailVerified && this.currentUser?.roles[0] !== 'SuperAdmin' && this.currentUser?.roles[0] !== 'Admin'"
	[class.close_icon]="navServices.collapseSidebar"
>
	<div class="header-wrapper row m-0">
		<div class="header-logo-wrapper col-auto p-0">
			<div class="logo-wrapper">
				<a routerLink="/">
					<img class="img-fluid for-light" src="assets/images/logo/logo.png" alt="" />
					<img class="img-fluid for-dark" src="assets/images/logo/logo_dark.png" alt="" />
				</a>
			</div>
			<div class="toggle-sidebar" (click)="sidebarToggle()">
				<app-feather-icons [icon]="'align-center'" class="status_toggle middle"></app-feather-icons>
			</div>
		</div>
		<div class="nav-right col-md-12 col-sm-12 pull-right right-header p-0 ms-auto">
			<ul class="nav-menus">
				<li class="profile-nav onhover-dropdown p-0" role="button">
					<app-project-selector></app-project-selector>
				</li>
				<li
					class="fullscreen-body d-flex gap-2 bg-white border border-gray-200 rounded-2 shadow-sm me-3 p-2 hover:shadow-md transition-all"
					*ngIf="
						['E-COMMERCE', 'COMMERCE', 'RESTAURANT', 'LIBRARY', 'SALON'].includes(
							this.selectedProject?.type
						) && hasAccessToPOS
					"
					role="button"
					(click)="this.router.navigate(['front/orders-management/' + selectedProject?._id + '/add'])"
				>
					<img src="assets/images/svg-icon/laptop.svg" style="width: 20px" />
					<span class="font-medium text-gray-800 me-2">{{ 'POS' | translate }}</span>
				</li>
				<li
					role="button"
					class="fullscreen-body d-flex gap-2 border border-gray-200 rounded-2 shadow-sm me-3 p-2 hover:shadow-md transition-all"
					style="background-color: #e04f16"
					(click)="openMathCalculator()"
				>
					<app-svg-icon [imageIcon]="'calculator-2'"></app-svg-icon>
				</li>
				<li class="fullscreen-body">
					<app-toggle-screen></app-toggle-screen>
				</li>
				<li class="onhover-dropdown">
					<app-notification></app-notification>
				</li>
				<li class="language-nav" (click)="languageToggle()">
					<app-languages></app-languages>
				</li>
				<li class="onhover-dropdown">
					<app-header-settings></app-header-settings>
				</li>
				<li class="profile-nav onhover-dropdown p-0" role="button">
					<app-my-account></app-my-account>
				</li>
			</ul>
		</div>
	</div>
</div>
<!-- User Header Ends -->

<!-- User Header Start-->
<div
	class="page-header"
	*ngIf="!emailVerified && this.currentUser?.roles[0] !== 'SuperAdmin' && this.currentUser?.roles[0] !== 'Admin'"
	style="background-color: #ffecf1"
	[class.close_icon]="navServices.collapseSidebar"
>
	<div class="header-wrapper row m-0">
		<div class="header-logo-wrapper col-auto p-0">
			<div class="logo-wrapper">
				<a routerLink="/">
					<img class="img-fluid for-light" src="assets/images/logo/logo.png" alt="" />
					<img class="img-fluid for-dark" src="assets/images/logo/logo_dark.png" alt="" />
				</a>
			</div>
			<div class="toggle-sidebar" (click)="sidebarToggle()">
				<app-feather-icons [icon]="'align-center'" class="status_toggle middle"></app-feather-icons>
			</div>
		</div>
		<div class="ps-1 left-header col-md-4 col-sm-3">
			<app-swiper></app-swiper>
		</div>
		<div class="nav-right col-md-8 col-sm-9 pull-right right-header p-0 ms-auto">
			<ul class="nav-menus">
				<li class="profile-nav onhover-dropdown p-0" role="button">
					<app-project-selector></app-project-selector>
				</li>
				<li
					class="fullscreen-body d-flex gap-2 bg-white border border-gray-200 rounded-2 shadow-sm me-3 p-2 hover:shadow-md transition-all"
					*ngIf="
						['E-COMMERCE', 'COMMERCE', 'RESTAURANT', 'LIBRARY', 'SALON'].includes(
							this.selectedProject?.type
						) && hasAccessToPOS
					"
					role="button"
					(click)="this.router.navigate(['front/orders-management/' + selectedProject?._id + '/add'])"
				>
					<img src="assets/images/svg-icon/laptop.svg" style="width: 20px" />
					<span class="font-medium text-gray-800 me-2">{{ 'POS' | translate }}</span>
				</li>
				<li
					role="button"
					class="fullscreen-body d-flex gap-2 border border-gray-200 rounded-2 shadow-sm me-3 p-2 hover:shadow-md transition-all"
					style="background-color: #e04f16"
					(click)="openMathCalculator()"
				>
					<app-svg-icon [imageIcon]="'calculator-2'"></app-svg-icon>
				</li>
				<li class="fullscreen-body">
					<app-toggle-screen></app-toggle-screen>
				</li>
				<li class="onhover-dropdown">
					<app-notification></app-notification>
				</li>
				<li class="language-nav" (click)="languageToggle()">
					<app-languages></app-languages>
				</li>
				<li class="onhover-dropdown">
					<app-header-settings></app-header-settings>
				</li>
				<li class="profile-nav onhover-dropdown p-0" role="button">
					<app-my-account></app-my-account>
				</li>
			</ul>
		</div>
	</div>
</div>
<!-- User Header Ends -->
